import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWaveDecision } from "@/generated/models/ApiWaveDecision";
import { WaveWinnersEmpty } from "./WaveWinnersEmpty";
import { format } from "date-fns";
import { WaveWinnersTimelineLoading } from "./WaveWinnersTimelineLoading";
import { WaveWinnersDrops } from "./drops/WaveWinnersDrops";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
interface WaveWinnersTimelineProps {
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly decisionPoints: ApiWaveDecision[];
  readonly wave: ApiWave;
  readonly isLoading: boolean;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const WaveWinnersTimeline: React.FC<WaveWinnersTimelineProps> = t0 => {
  const $ = _c(26);
  const {
    onDropClick,
    decisionPoints,
    wave,
    isLoading,
    contentPresentation
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WaveWinnersTimelineLoading />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const hasAnyWinners = decisionPoints.some(_temp);
  if (decisionPoints.length === 0 || !hasAnyWinners) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WaveWinnersEmpty />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== contentPresentation || $[3] !== decisionPoints || $[4] !== onDropClick || $[5] !== wave) {
    const sortedDisplayPoints = [...decisionPoints].filter(_temp2).sort(_temp3);
    t5 = "tw-overflow-y-auto tw-pt-4 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300";
    t3 = "tw-relative";
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="tw-absolute tw-bottom-0 tw-left-2 tw-top-0 tw-w-px tw-bg-iron-700/80 lg:tw-left-[19px]" />;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t1 = "tw-space-y-6";
    let t6;
    if ($[12] !== contentPresentation || $[13] !== onDropClick || $[14] !== wave) {
      t6 = point_1 => {
        const date = new Date(point_1.decision_time);
        const formattedDate = format(date, "EEE, MMM d, yyyy");
        const formattedTime = format(date, "h:mm a");
        return <div key={`decision-${point_1.decision_time}`} className="group tw-relative"><div className="tw-absolute tw-left-0 tw-top-[0.3125rem] tw-z-10 lg:tw-left-3"><div className="tw-flex tw-size-4 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-iron-700/50 tw-bg-iron-800 tw-transition-all group-hover:tw-border-iron-500"><div className="tw-size-2 tw-rounded-full tw-bg-iron-500 tw-transition-all group-hover:tw-size-2.5 group-hover:tw-bg-iron-400" /></div></div><div className="tw-mb-2 tw-ml-6 lg:tw-mb-3 lg:tw-ml-10"><div className="tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-3 tw-gap-y-1"><h3 className="tw-text-sm tw-font-medium tw-tracking-wide tw-text-iron-300">{formattedDate}</h3><span className="tw-text-xs tw-font-light tw-tracking-wide tw-text-iron-400">{formattedTime}</span></div></div><div className="tw-mb-6 tw-ml-6"><div className="lg:tw-px-4 lg:tw-pb-4"><WaveWinnersDrops winners={point_1.winners} onDropClick={onDropClick} wave={wave} isLoading={false} contentPresentation={contentPresentation} /></div></div></div>;
      };
      $[12] = contentPresentation;
      $[13] = onDropClick;
      $[14] = wave;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t2 = sortedDisplayPoints.map(t6);
    $[2] = contentPresentation;
    $[3] = decisionPoints;
    $[4] = onDropClick;
    $[5] = wave;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t5 || $[24] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[23] = t5;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
function _temp(point) {
  return point.winners.length > 0;
}
function _temp2(point_0) {
  return point_0.winners.length > 0;
}
function _temp3(a, b) {
  return new Date(b.decision_time).getTime() - new Date(a.decision_time).getTime();
}